export enum rolesEnum {
    superAdmin = "maiq_super_admin",
    superUser = "super_user",
    dealershipGroupExecutive = "dealership_group_executive",
    dealershipExecutive = "dealership_executive",
    techUser = "maiq_tech_user",
    salesUser = "maiq_sales_user",
    salesPerson = "sales_person",
    performanceManager = "maiq_performance_manager",
    betaPerformanceManager = "beta_maiq_performance_manager"
}